module.exports = __webpack_public_path__ + "static/img/luqulogo.f9e85eab.png";